<script lang="ts">
  import { TextGradient } from '@shared/ui/text-gradient';

  import CardInfo from './auction-card-info.svelte';

  export let isUserBestBidder: boolean;
  export let bestBid: string | undefined;
  export let price: string;
</script>

<div class="flex gap-4 md:justify-start lg:gap-7">
  <CardInfo {isUserBestBidder} {bestBid} {price} />

  <TextGradient>Auction is finalizing</TextGradient>
</div>
